








































































































import { SharedState } from "@/common/state";
import RegulatedDashboardItem from "./RegulatedDashboardItem.vue";
import { computed, onBeforeUnmount } from "@vue/composition-api";
import Vue from "vue";
import DashboardItem from "@/views/overview/common/DashboardItem.vue";
import { BaseDashboardItem } from "./models";
import { state } from "./state";
import Sensitivities from "@/components/filters-bar/Sensitivities.vue";
import { UseModal } from "@/components/root/modal";
import { AxisType } from "@/gql/types";
import { cord } from "@/gql/lib";
import InformationCountModal from "../information-count-modal/InformationCountModal.vue";
import { InformationTypeTree } from "@/common/models";
import { UseTabs } from "@/common/composition/use-tabs";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import PIIBoard from "./pii-dashboard/PIIBoard.vue";
import FilesTableModalVue from "../files-table-modal/FilesTableModal.vue";
import { state as on_prem_state } from "../data/state";
export default Vue.extend({
  components: {
    DashboardItem,
    RegulatedDashboardItem,
    Sensitivities,
    SimpleNavTabs,
    PIIBoard,
  },
  setup(_, { root: { $router } }) {
    const [tabs, selected_tab, set_selected_tab] = UseTabs<{
      id: string;
      name: string;
      icon: string;
      enabled: boolean;
    }>(
      [
        {
          id: "sensitive",
          name: "Sensitive Information",
          icon: "Label",
          enabled: true,
        },
        {
          id: "personal",
          name: "Personal Identifiers",
          icon: "Regulated",
          enabled: true,
        },
      ],
      0
    );

    const {
      display_items,
      is_loading,
      sensitivities,
      toggle_sensitivity,
    } = state;
    const frame_date = computed(
      () => SharedState.selectedTimeFrameDisplayName.value
    );

    onBeforeUnmount(() => state.destroy());

    const on_item_clicked = async (item: BaseDashboardItem) => {
      SharedState.ifIsPayingUser(
        async () => {
          const info_type = SharedState.getInfoType(item.id)!;
          if (SharedState.restrictions.is_restricted_info(info_type.code)) {
            SharedState.restrictions.show_restrictions_modal(
              "info",
              info_type.labelName
            );
            return;
          }
          const label = SharedState.getInfoType(item.id)!;
          if (label.generation == 0 || label.has_children) {
            view_labels_tree_for_label(item);
          } else {
            await UseModal().show(FilesTableModalVue, {
              session_id: on_prem_state.selected_session.value!.id,
              label_id: item.id,
              label_name: item.name,
            });
          }
        },
        { premium_modal_key: "what-popup-2024" }
      );
    };

    const view_labels_tree_for_label = async (item: {
      id: string;
      name: string;
    }) => {
      const info_type = SharedState.getInfoType(item.id)!;
      if (SharedState.restrictions.is_restricted_info(info_type.code)) {
        SharedState.restrictions.show_restrictions_modal(
          "info",
          info_type.labelName
        );
        return;
      }
      await UseModal().show(InformationCountModal, {
        labels_tree: state.get_label_in_tree(item.id),
        label_id: item.id,
        label_name: item.name,
        session_id: on_prem_state.selected_session.value!.id,
      });
    };

    return {
      feature_pii: SharedState.FeatureHelper.is_enabled("pii_labeler"),
      // tabs
      tabs,
      selected_tab,
      set_selected_tab,
      // rest
      sensitivities,
      toggle_sensitivity,
      frame_date,
      is_loading,
      regular_content_types_items: computed(() =>
        display_items.value.slice(0, display_items.value.length - 1)
      ),
      other_item: computed(() => {
        const other = display_items.value[display_items.value.length - 1];
        other.items = other.items.filter(
          (d: { id: string }) => d.id !== SharedState.default_label_id.value
        );
        return other;
      }),
      view_labels_tree_for_label,
      on_item_clicked,

      user_has_ms: SharedState.data_sources_includes_ms,
      feature_custom_info_type_enabled: computed(() =>
        SharedState.FeatureHelper.is_enabled("custom_information_type")
      ),
      nav_to_create_custom_info_type: () => {
        $router.push({
          name: "InformationCustomization",
          query: { action: "add_custom" },
        });
      },
    };
  },
});
